export default "__VITE_PUBLIC_ASSET__010ae933__"